import { LocationGroup } from 'src/app/core/models/admin';
import { UapLocation } from 'src/app/core/models/admin/adl.model';

export const CONSTANTS = {
  UNASSIGN_BUTTON_TEXT: $localize`Unassign`,
  ASSIGN_BUTTON_TEXT: $localize`Assign`,
  SEARCH_PLACEHOLDER: $localize`Search Here`,
};

export type TwoColumnFormData = {
  data: UapLocation | LocationGroup;
  selected: boolean;
};
